import { useOktaAuth } from '@okta/okta-react';
import { useEffect, useState } from 'react';
import PageLoadingSpinner from '../../Components/LoadingSpinner/PageLoadingSpinner';
import loggingService from '../../Services/Logging/LoggingService';

// Adopted from https://github.com/okta/okta-auth-js
const OktaLoginCallback: React.FC = () => {
    const { oktaAuth, authState } = useOktaAuth();
    const [callbackError, setCallbackError] = useState<Error | null>(null);
    const authError = authState?.error;
    const displayError = callbackError || authError;

    useEffect(() => {
        if (oktaAuth.isLoginRedirect()) {
            oktaAuth
                .handleRedirect()
                .then(() => {
                    oktaAuth.start();
                })
                .catch((error) => {
                    setCallbackError(error);
                });
        } else {
            oktaAuth
                .isAuthenticated()
                .then((authenticated) => {
                    if (!authenticated) {
                        oktaAuth.signInWithRedirect();
                    }
                })
                .catch((error) => {
                    setCallbackError(error);
                });
        }
    }, [oktaAuth]);

    useEffect(() => loggingService.trackException(displayError), [displayError]);

    return <PageLoadingSpinner />;
};

export default OktaLoginCallback;
